import React from "react";
import { Tooltip, TooltipProps } from "@mui/material";
import { MuiBox, MuiTypography } from "..";
import { MuiEllipseLabelWrapper } from "./MuiEllipseLabel.style";
import { TypographyProps } from "@mui/material/Typography";

interface MuiEllipseLabelProps {
  text?: string | React.ReactNode;
  labelTypoVariant?: TypographyProps["variant"];
  labelTypoClassName?: string;
  wrapperClassName?: string;
  placement?: TooltipProps["placement"];
  titleIcon?: React.ReactNode;
  onClick?: () => void;
  pointerCursor?: boolean;
}

const MuiEllipseLabel: React.FC<MuiEllipseLabelProps> = ({
  text,
  labelTypoVariant,
  labelTypoClassName = "",
  wrapperClassName = "",
  placement = "bottom",
  titleIcon,
  onClick,
  pointerCursor,
}) => {
  const customStyle = `${labelTypoClassName} ${pointerCursor ? "with-cursor-pointer" : ""}`;
  return (
    <MuiEllipseLabelWrapper className={wrapperClassName}>
      {titleIcon}
      <MuiBox className="ellipse-label-box">
        <Tooltip title={text} placement={placement}>
          <MuiTypography
            className={`ellipse ${customStyle}`}
            variant={labelTypoVariant}
            component={"label"}
            onClick={onClick}
            data-testid="ellipse-label-text"
          >
            {text}
          </MuiTypography>
        </Tooltip>
      </MuiBox>
    </MuiEllipseLabelWrapper>
  );
};

export default MuiEllipseLabel;
